<template>
  <Popover
    class="pg-layout-menu-short"
    popper-class="pg-layout-menu-short__popper"
    placement="left-start"
    trigger="click"
    v-model="isShow"
  >
    <template #reference>
      <div
        class="pg-layout-menu-short__tag"
        :class="{ 'pg-layout-menu-short__tag--active': isShow }"
      >
        <i class="ivu-icon-icon-pg-sycd pg-layout-menu-short__icon"></i>
        <span class="pg-layout-menu-short__tag-text" v-show="!collapse">全部菜单</span>
        <i class="el-icon-arrow-right" v-show="!collapse"></i>
      </div>
    </template>
    <div class="pg-layout-menu-short__popper-content">
      <template v-for="one in menuList">
        <div class="pg-layout-menu-short__popper-content-one" :key="one.id">
          <div class="pg-layout-menu-short__popper-content-one-title">
            <span
              :class="{ 'one-hover': !one.children?.length, 'one-active': activeMenu === one.id }"
              @click="toMenu(one)"
              >{{ one.title }}</span
            >
          </div>
        </div>
        <template v-if="one.children?.length > 0">
          <template v-for="two in one.children">
            <div class="pg-layout-menu-short__popper-content-item-two" :key="two.id">
              <div class="pg-layout-menu-short__popper-content-item-two-title">
                <span class="pg-layout-menu-short__popper-content-item-two-title-header"
                  ><span
                    :class="{
                      'two-hover': !two.children?.length,
                      'two-active': activeMenu === two.id,
                    }"
                    @click="toMenu(two)"
                    >{{ two.title }}</span
                  ><i class="el-icon-arrow-right" v-if="two.children?.length > 0"></i
                ></span>
              </div>
            </div>
            <div
              class="pg-layout-menu-short__popper-content-item-three"
              v-if="two.children?.length > 0"
              :key="two.children?.length + two.id"
            >
              <span
                class="pg-layout-menu-short__popper-content-item-three-title"
                :class="{ 'three-active': activeMenu === three.id }"
                v-for="three in two.children"
                :key="three.id"
                @click="toMenu(three)"
                >{{ three.title }}</span
              >
            </div>
          </template>
        </template>
      </template>
    </div>
  </Popover>
</template>
<script setup>
import { Popover } from 'element-ui'
import { ref, toRef } from 'vue'
import { useActiveMenu } from '../hook/use-menu-list'

const props = defineProps({
  menuList: Array,
  collapse: Boolean,
})

const { activeMenu, selectMenu } = useActiveMenu(toRef(props, 'menuList'))
const toMenu = (menu) => {
  if (!menu.children?.length) {
    const success = selectMenu(menu.id)
    if (success) {
      isShow.value = false
    }
  }
}

const isShow = ref(false)
</script>
<style lang="scss">
@import '../style/layout-menu-short.scss';
</style>
